 import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
 
import {appApiResources} from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetContactInfoService {

  constructor(private http: HttpClient) {}

  async GetContactInfo(key) {
    try {
      // const httpOptions = {
      //   headers: new HttpHeaders({
      //     "Content-Type": "application/json",
      //     Authorization: `jwt ${idToken}`
      //   })
      // }; 
      let response = await this.http
        .get(`${appApiResources.getContactInfo}?search=${key}`)
        .toPromise();
      return response;
    } catch (error) { 
      return error;
    }
  }
}